import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import { encryptTransform } from 'redux-persist-transform-encrypt';

//Whenever app gets booted up it runs all the reducers once so initial state is null
const INITIAL_STATE = {
    name: "",
    token: "",
    email: "",
    // Phase 2 §11. Defaults to 'main' so any state persisted before this field
    // existed (or a login response from before the backend added it) doesn't
    // accidentally read as a read-only sub-admin.
    role: "main"
};


const authReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case "SIGN_IN":
            return { ...state, name: action.payload.data.name, token: action.payload.data.token, email: action.payload.data.email, role: action.payload.data.role || "main" };
        case "SIGN_OUT":
            state = undefined;
            return (state = INITIAL_STATE);
        default:
            return state;
    }
};

const persistConfig = {
    key: 'auth',
    storage: storage,
    blacklist: [],
    transforms: [
        encryptTransform({
            secretKey: (process.env.REACT_APP_MY_SECRET),
            onError: function (error) {
                // Handle encryption errors
                // console.log(error)
            },
        })
    ],
};

export default persistReducer(persistConfig, authReducer);